import React, { useState, useEffect } from 'react';
import { appConfigService } from '../../../services';
import { DataTable } from '../../../components';
import { useModalDialog, useGlobalState, useMessage } from '../../../hooks';
import { useWebhookDialog } from '../hooks';
import { getWebhookScopeLabel } from '../helpers';

import { Role } from '../../../helpers';

// The "Webhooks" tab of the App Config page: per-app outbound webhook CRUD, backed by the
// generic core.app_config store via appConfigService. Also usable standalone.
export const Webhooks = () => {

  const [webhooks, setWebhooks] = useState([]);
  const [loggedInUser] = useGlobalState('loggedInUser');
  const [selectedItems, setSelectedItems] = useState([]);
  const [loading, setLoading] = useState(true);

  const { showMessage } = useMessage()
  const { hideModalDialog } = useModalDialog()
  const { showAddWebhookDialog, showEditWebhookDialog, showDeleteWebhookDialog } = useWebhookDialog()

  useEffect(() => {
    fetchItems();
  }, []);

  const fetchItems = async () => {
    await appConfigService.getWebhooks()
      .then(res => {
        setWebhooks(res.webhooks.map(w => ({ ...w, app_display_name: getWebhookScopeLabel(w.scope) })));
        setLoading(false);
      })
      .catch(err => {
        setLoading(false)
        showMessage(JSON.stringify(err), 'error')
      })
  }

  const saveWebhook = async data => {
    await appConfigService.upsertWebhook(data)
      .then(res => {
        fetchItems()
        showMessage('Webhook sparad')
        clearSelectedItems()
        hideModalDialog()
      })
      .catch(err => {
        showMessage(JSON.stringify(err), 'error')
      })
  }

  const deleteWebhook = async item => {
    await appConfigService.removeWebhook(item.scope)
      .then(res => {
        fetchItems()
        showMessage(res.message)
        clearSelectedItems()
        hideModalDialog()
      })
      .catch(err => {
        showMessage(JSON.stringify(err), 'error')
      })
  }

  const clearSelectedItems = () => setSelectedItems([])

  const editable = loggedInUser && loggedInUser.user_role_name === Role.admin

  const enabledValues = { true: { label: 'Enabled', className: 'pill' }, false: { label: 'Disabled', className: 'pill pill-red' } }
  const configuredValues = { true: { label: 'Yes', className: 'pill' }, false: { label: 'No', className: 'pill pill-red' } }

  return (
    <div className="Webhooks">

        <DataTable
          columns={[
            {id: 'app_display_name', name: 'App', className: 'bold'},
            {id: 'label', name: 'Label'},
            {id: 'enabled', name: 'Status', type: 'boolean', values: enabledValues},
            {id: 'is_configured', name: 'Configured', type: 'boolean', values: configuredValues},
          ]}
          buttons={[
            {label: "Add +", action: "add", mainButton: true, onClick: () => showAddWebhookDialog(saveWebhook, webhooks.map(w => w.scope)) },
            {label: "Edit", action: "edit", onClick: (items) => showEditWebhookDialog(items || selectedItems, saveWebhook) },
            {label: "Delete", action: "delete", onClick: (items) => showDeleteWebhookDialog(items || selectedItems, deleteWebhook) }
          ]}
          data={webhooks}
          title="Webhooks"
          idColumn='scope'
          primaryColumn='app_display_name'
          selectedItems={selectedItems}
          setSelectedItems={setSelectedItems}
          loading={loading}
          editable={editable}
          filterable={true}
          filterObjects={['app_display_name', 'label']}
        />

      </div>
  );
}
